/* eslint-disable max-len */
// BASIC INFO
const BASIC_INFO = 'RECEIVE,F.DIST Code,TWC No.,Initial Process Date,Page,Claimant,Franchise,Warranty Type,Data ID,Non Vehicle Flag,Ope. Type,Process Date,Process Flag,Invoice No.,Dealer,Dealer CLM No.,Curr.,Currency Conv. Rate Local to invoice Curr.,PRR1,Labor Rate,T1 Code,T2 Code,WMI,VDS,C/D,VIS,';

// T3 code (Position Code)
const T3_CODE = 'Position01,Position02,Position03,Position04,Position05,Position06,Position07,';

// Warranty dates
const WARRANTY_DATES = 'Repair Open Date,Rep. Comp. Date,Delivery Date,Mileage,Kilo-Mile Flag,Repair Order No.,Prev. R/O No.,Prev. Rep. Comp. Date,';

// P&A Additional Information
const ADDITIONAL_INFO = 'Acc. First Inst. Date,Acc. First Inst. Mileage,Prev. Rep. Mileage,Prev. Inv. No.,Curr. Inv. No.,';

// Amount and Labor time
const LABOR_TIME = 'Amt. Parts (not incl. TAX),Hour Total,Amt. Labor (not incl. TAX),Amt. Sublet (not incl. TAX),Amout Grand Total,';

// Dist.s Claim Adjustment
const CLAIM_SECTION = 'Adj from Claimant(%) Parts,Adj from Claimant(%) Labor,Adj from Claimant(%) Sublet,';

// OFP Local Flag
const OFP_LOCAL_FLAG = 'OFP Local Flag,OFP,';

// Parts
const PARTS_SECTION = 'Parts Pay Code01,Parts Local Flag01,Parts No.01,Parts QTY01,Parts Amount01,Multi PRR01,Parts Pay Code02,Parts Local Flag02,Parts No.02,Parts QTY02,Parts Amount02,Multi PRR02,Parts Pay Code03,Parts Local Flag03,Parts No.03,Parts QTY03,Parts Amount03,Multi PRR03,Parts Pay Code04,Parts Local Flag04,Parts No.04,Parts QTY04,Parts Amount04,Multi PRR04,Parts Pay Code05,Parts Local Flag05,Parts No.05,Parts QTY05,Parts Amount05,Multi PRR05,Parts Pay Code06,Parts Local Flag06,Parts No.06,Parts QTY06,Parts Amount06,Multi PRR06,';

// Labor
const LABOR_SECTION = 'Labor Ope. No. (Main),Labor Pay Code01,Labor Ope. No.01,Labor Hour01,Labor Pay Code02,Labor Ope. No.02,Labor Hour02,Labor Pay Code03,Labor Ope. No.03,Labor Hour03,';

// Sublet
const SUBLET_SECTION = 'Sublet Pay Code01,Sublet Type1,Sublet Inv. No.01,Sublet Amount01,Sublet Description01,Sublet Pay Code02,Sublet Type2,Sublet Inv. No.02,Sublet Amount02,Sublet Description02,';

// Comment
const COMMENT_SECTION = 'Condition Description,Cause Description,Remedy Description,F.Dist. Comment,';

// Evidence Flag
const EVIDENCE_FLAG = 'Evidence Flag,';

// Warranty Application Code
const WARRANTY_APP_CODES = 'Warranty Application FLG1,Warranty Application FLG2,Warranty Application FLG3,Warranty Application FLG4,Warranty Application FLG5,';

// Battery test code
const BATTERY_CODES = 'Battery Test Code1-1,Battery Test Code1-2,Battery Test Code2-1,Battery Test Code2-2,';

// Diag code
const DIAG_CODES = 'DIAG Code1,DIAG Code2,DIAG Code3,DIAG Code4,DIAG Code5,';

// TSB
const TSB_SECTION = 'TSB No. (Dist),';

// Serial Code
const SERIAL_CODE_SECTION = 'Serial No.1,Serial No.2,Serial No.3';

export const COUNTRY_JPY = 'JPY';

export const REPORT_HEADERS = BASIC_INFO +
                              T3_CODE +
                              WARRANTY_DATES +
                              ADDITIONAL_INFO +
                              LABOR_TIME +
                              CLAIM_SECTION +
                              OFP_LOCAL_FLAG +
                              PARTS_SECTION +
                              LABOR_SECTION +
                              SUBLET_SECTION +
                              COMMENT_SECTION +
                              EVIDENCE_FLAG +
                              WARRANTY_APP_CODES +
                              BATTERY_CODES +
                              DIAG_CODES +
                              TSB_SECTION +
                              SERIAL_CODE_SECTION;
